export interface MeuPerfil {
  participante_id: number | null;
  nome: string;
  cpf: string | null;
  nascimento: string | null;
  telefone: string | null;
  email: string | null;
  cep: string | null;
  endereco: string | null;
  complemento: string | null;
  bairro: string | null;
  cidade: string | null;
  uf: string | null;
  foto_url: string | null;
  cadastro_incompleto: boolean;
}

export interface HistoricoItem {
  ano: number;
  evento: string;
  evento_slug: string;
  participacao: string;
  grupo: string | null;
  equipe: string | null;
  status: string;
  ja_aconteceu: boolean;
}

export type BlocoNome = 'quem' | 'onde';

// Rascunho de edição: CPF, telefone e CEP já vêm com máscara para facilitar o preenchimento.
export interface RascunhoPerfil {
  nome: string;
  cpf: string;
  nascimento: string;
  telefone: string;
  cep: string;
  endereco: string;
  complemento: string;
  bairro: string;
  cidade: string;
  uf: string;
}

export const UFS = [
  'AC',
  'AL',
  'AP',
  'AM',
  'BA',
  'CE',
  'DF',
  'ES',
  'GO',
  'MA',
  'MT',
  'MS',
  'MG',
  'PA',
  'PB',
  'PR',
  'PE',
  'PI',
  'RJ',
  'RN',
  'RS',
  'RO',
  'RR',
  'SC',
  'SP',
  'SE',
  'TO',
];